import React, { useState, useEffect } from "react";
import axios from "axios";
import CreaEstandarAsistencial from "./CreaEstandarAsistencial";
import Cookies from "universal-cookie";
import AdjuntoEstandar from "./AdjuntoEstandar";
import ActualizaEstandar from "./ActualizaEstandar";
import LeerMas from "./LeerMas"; // ⬅️ IMPORTANTE

function EstandarAsistencial(props) {
  const cookies = new Cookies();

  const [country, setCountry] = useState([]);
  const [countryid, setCountryid] = useState("");
  const [st, setSt] = useState([]);
  const [stateid, setStateid] = useState([]);
  const [city, setCity] = useState([]);
  const [subCriterio, setSubCriterios] = useState([]);
  const [list, setList] = useState([]);

  useEffect(() => {
    const getcountry = async () => {
      const rescountry = await fetch(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEstandaresApoyoAsistenciales?TipoEstandar=Asistencial",
      );
      const rescon = await rescountry.json();
      setCountry(await rescon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    setCountryid(event.target.value);
  };

  useEffect(() => {
    if (countryid !== "") {
      const getstate = async () => {
        const resstate = await fetch(
          "https://suadesarrollo.azurewebsites.net/api/ObtenerCriterios?IdEstandar=" +
            countryid,
        );
        const resst = await resstate.json();
        setSt(await resst);
      };
      getstate();
    }
  }, [countryid]);

  const handlestate = (event) => {
    setStateid(event.target.value);
  };

  useEffect(() => {
    if (stateid !== "") {
      const getcity = async () => {
        const rescity = await fetch(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerSubCriterios?IdCriterio=` +
            stateid,
        );
        const rcity = await rescity.json();
        setCity(await rcity);
      };
      getcity();
    }
  }, [stateid]);

  // --------- LISTA PRINCIPAL ----------
  useEffect(() => {
    axios({
      method: "get",
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEstandarCualitativoPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const filtro = list.filter((e) => e.tipo === "Asistencial");

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  // ---------- PAGINACIÓN ----------
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(filtro.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filtro.slice(indexOfFirst, indexOfLast);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Estandares Asistencial
              </h6>

              <hr />

              {cookies.get("tipo_Usuario") == 2 &&
              nombreRuta === "ProcesoAutoevaluacion" ? (
                <CreaEstandarAsistencial solicitudId={props.idSolicitud} />
              ) : null}

              <div className="table-responsive">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Estandar</th>
                      <th>Fortalezas</th>
                      <th>Elementos Verificación</th>
                      <th>Oportunidad Mejora</th>
                      <th>Anexos</th>
                      <th>Editar</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.estandar}</td>

                        <td>
                          <LeerMas texto={item.fortalezas} limite={120} />
                        </td>

                        <td>
                          <LeerMas
                            texto={item.elementosVerificacion}
                            limite={120}
                          />
                        </td>

                        <td>
                          <LeerMas
                            texto={item.oportunidadMejora}
                            limite={120}
                          />
                        </td>

                        {nombreRuta === "ProcesoAutoevaluacion" && (
                          <td>
                            <AdjuntoEstandar id={item.id} />
                          </td>
                        )}

                        {nombreRuta === "ProcesoAutoevaluacion" && (
                          <td>
                            <ActualizaEstandar
                              id={item.id}
                              fortaleza={item.fortalezas}
                              elemento={item.elementosVerificacion}
                              oportunidad={item.oportunidadMejora}
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ---------- PAGINADOR ---------- */}
              <div className="d-flex justify-content-center mt-3">
                <nav>
                  <ul className="pagination">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => goToPage(currentPage - 1)}
                      >
                        Anterior
                      </button>
                    </li>

                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (number) => (
                        <li
                          key={number}
                          className={`page-item ${
                            currentPage === number ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => goToPage(number)}
                          >
                            {number}
                          </button>
                        </li>
                      ),
                    )}

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => goToPage(currentPage + 1)}
                      >
                        Siguiente
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* Fin paginador */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstandarAsistencial;
